import type { TagAppearance } from '@fourthwall/components'

import type { TransactionStatus } from './Billing.types'

export const TAB_TITLES = {
  payouts: 'Payouts',
  charges: 'Charges',
}

export const tagsAppearances: Record<TransactionStatus, TagAppearance> = {
  PAID: 'success',
  PROCESSING: 'alert',
  FAILED: 'critical',
  REVERTED: 'alert',
}
